import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import {
  border,
  color,
  compose,
  space,
  SpaceProps,
  textStyle,
} from 'styled-system'

type CountChipProps = SpaceProps & { inline?: boolean }

export const CountChip = styled.div
  .withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop),
  })
  .attrs({
    px: 'xs',
    borderRadius: '8px',
    border: `1px solid ${palette.neutral['200']}`,
    bg: palette.neutral['50'],
    color: palette.neutral['600'],
    textStyle: 'subtitle.3',
  })<CountChipProps>`
  display: ${(props) => (props.inline ? 'inline-flex' : 'flex')};
  align-items: center;
  justify-content: center;
  ${compose(space, border, color, textStyle)}
  min-width: 20px;
`
